<ng-container *transloco="let t;">
<form (submit)="onSubmit()" novalidate *ngIf="exercise !== null">

  <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.exerciseparts') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true && inOrdering !== true">
        <button *ngIf="items.length > 0" withRight="admin.exercisepart.create" pButton type="button" (click)="menu.toggle($event)" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
        <button *ngIf="exercise.exerciseparts?.length > 1" withRight="admin.exercise.edit" pButton (click)="onStartOrdering()" type="button" label="{{ t('common.labels.sequence') }}" icon="pi pi-list" class="p-button-sm p-button-outlined p-mb-2 p-ml-2"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inOrdering === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
  </div>

  <p-table *ngIf="inEdit === true || exercise.exerciseparts?.length > 0" [value]="exercise.exerciseparts" [reorderableColumns]="inOrdering === true" (onRowReorder)="onRowReorder($event)">
    <ng-template pTemplate="header">
      <tr>
          <th style="width: 3rem" *ngIf="inOrdering === true"></th>
          <th>{{ t('common.labels.name') }}</th>
          <th>{{ t('common.labels.forerun_duration') }}</th>
          <th>{{ t('common.labels.relevance') }}</th>
          <th>{{ t('common.labels.rating_start') }}</th>
          <th>{{ t('common.labels.rating_duration') }}</th>
          <th></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-exercisepart let-index="rowIndex">
      <tr *ngIf="(inEdit !== true || exercisepart !== editExercisepart) && exercisepart.type !== 'normal'">
        <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ exercisepart: exercisepart }"></ng-template>
      </tr>
      <tr *ngIf="(inEdit !== true || exercisepart !== editExercisepart) && exercisepart.type === 'normal'" [pReorderableRow]="index">
        <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ exercisepart: exercisepart }"></ng-template>
      </tr>
      <tr *ngIf="inEdit === true && editExercisepart === exercisepart">
        <ng-template [ngTemplateOutlet]="tForm"></ng-template>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr *ngIf="inEdit === true && editExercisepart === null">
        <ng-template [ngTemplateOutlet]="tForm"></ng-template>
      </tr>
    </ng-template>
  </p-table>

  <!-- ROW TEMPLATE -->
  <ng-template #row let-exercisepart="exercisepart">
    <td *ngIf="inOrdering === true">
      <span *ngIf="exercisepart.type === 'normal'" class="pi pi-bars" pReorderableRowHandle></span>
    </td>
    <td>{{exercisepart.name}}</td>
    <td>
      <span *ngIf="exercisepart.type === 'normal'">
        {{exercisepart.duration}} {{ t('common.labels.minutes') }}
      </span>
      <span *ngIf="exercisepart.type === 'before'">
        {{exercisepart.unlock_days}} {{ t('common.labels.days') }}
      </span>
    </td>
    <td>
      <fa-icon *ngIf="exercisepart.for_candidate === true" [icon]="faStreetView" class="p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon>
      <fa-icon *ngIf="exercisepart.for_observer === true" [icon]="faUsers" class="p-ml-2" pTooltip="{{ t('common.labels.observer') }}"></fa-icon>
    </td>
    <td>
      <span *ngIf="exercisepart.type === 'normal'">
        {{ t(exercisepart.getRatingStartName()) }}
      </span>
    </td>
    <td>
      <span *ngIf="exercisepart.type === 'normal' && exercisepart.rating_duration !== null">{{exercisepart.rating_duration}} {{ t('common.labels.minutes') }}</span>
    </td>
    <td style="text-align: right">
      <span *ngIf="inEdit !== true && inOrdering !== true">
        <button withRight="admin.exercisepart.edit" pButton (click)="onEdit(exercisepart)" type="button" icon="pi pi-pencil"></button>
        <button withRight="admin.exercisepart.delete" pButton (click)="onDelete(exercisepart)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="!exercisepart.deletable"></button>
      </span>
    </td>
  </ng-template>
  <!-- ROW TEMPLATE -->

  <!-- FORM TEMPLATE -->
  <ng-template #tForm>
    <td>
      <div class="p-inputgroup" *ngIf="editType === 'normal' || editType === 'before'">
        <input [formControl]="form.get('name')" type="text" aria-describedby="name-help" pInputText />
        <app-form-error [control]="form.get('name')" [label]="t('common.labels.name')"></app-form-error>
      </div>
    </td>
    <td>
      <div class="p-inputgroup" *ngIf="editType === 'normal'">
        <p-inputNumber [formControl]="form.get('duration')" type="text" aria-describedby="duration-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="0" max="240"></p-inputNumber>
        <app-form-error [control]="form.get('duration')" [label]="t('common.labels.duration')"></app-form-error>
      </div>
      <div class="p-inputgroup" *ngIf="editType === 'before'">
        <p-inputNumber [formControl]="form.get('unlock_days')" type="text" aria-describedby="unlock_days-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="1" max="60"></p-inputNumber>
        <app-form-error [control]="form.get('unlock_days')" [label]="t('common.labels.forerun')"></app-form-error>
      </div>
    </td>
    <td>
      <div class="p-grid" *ngIf="editType === 'normal'">
        <div class="p-col-6">
          <div class="p-field-checkbox p-mb-0">
            <p-checkbox [formControl]="form.get('relevance.for_candidate')" binary="true"></p-checkbox>
            <label for="description"><fa-icon [icon]="faStreetView" class="p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon></label>
          </div>
        </div>
        <div class="p-col-6">
          <div class="p-field-checkbox p-mb-0">
            <p-checkbox [formControl]="form.get('relevance.for_observer')" binary="true"></p-checkbox>
            <label for="description"><fa-icon [icon]="faUsers" class="p-ml-2" pTooltip="{{ t('common.labels.observer') }}"></fa-icon></label>
          </div>
        </div>
      </div>
      <app-form-error *ngIf="editType === 'normal'" [control]="form.get('relevance')" [label]="t('common.labels.please_choose_candidate_observer')" [inline]="true"></app-form-error>
      <fa-icon *ngIf="editType === 'before'" [icon]="faStreetView" class="p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon>
    </td>
    <td>
      <div class="p-inputgroup" *ngIf="editType === 'normal'">
        <p-dropdown [options]="optionsRatingStart" [formControl]="form.get('rating_start')" aria-describedby="rating_start-help" ></p-dropdown>
        <app-form-error [control]="form.get('rating_start')" [label]="t('common.labels.rating_start')"></app-form-error>
      </div>
    </td>
    <td>
      <div class="p-inputgroup" *ngIf="editType === 'normal'">
        <p-inputNumber [formControl]="form.get('rating_duration')" type="text" aria-describedby="rating_duration-help" [showButtons]="true" mode="decimal" [minFractionDigits]="0" [maxFractionDigits]="0" min="0" max="240" step="5"></p-inputNumber>
        <app-form-error [control]="form.get('rating_duration')" [label]="t('common.labels.rating_duration')"></app-form-error>
      </div>
    </td>
    <td style="text-align: right">
      <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
    </td>
  </ng-template>
  <!-- FORM TEMPLATE -->

  <p *ngIf="inEdit !== true && exercise.exerciseparts?.length === 0">{{ t('common.texts.no_exerciseparts') }}</p>

  <p class="p-mt-4 p-text-small">{{ t('exercise_parts.hint_for_inheritance') }}</p>

</form>
</ng-container>
